import { SurfaceState } from 'lib/a2ui'
import { AgentConversationType, UIMessage, UIMessageActionItem } from 'pbts/c1/api/conversations/v1/conversations'
import { ReactNode } from 'react'

/**
 * Timeline item representing either a message or an A2UI surface.
 * Used to merge and sort messages with surfaces for chronological display.
 */
export type TimelineItem = {
    type: 'message' | 'surface'
    id: string
    ts: number
    data: UIMessage | SurfaceState
}

/**
 * Props for the unified CopilotAssistant component.
 */
export type CopilotAssistantProps = {
    // Required
    conversationType: AgentConversationType
    conversationTitle: string

    // Customization
    metadata?: Record<string, unknown>
    renderActionItem?: (actionItem: UIMessageActionItem) => ReactNode
    /**
     * Handler for A2UI surface actions. Return true to indicate the action was handled
     * locally and should NOT be sent to the backend.
     */
    onLocalAction?: (actionName: string, context: Record<string, string>, surfaceState: SurfaceState) => boolean | void
    placeholder?: string

    // Zero state - can be a ReactNode or a render function that receives onSuggestionClick
    /**
     * Custom zero state. Can be:
     * - ReactNode: static content
     * - Function: receives onSuggestionClick to set input text
     */
    zeroState?: ReactNode | ((onSuggestionClick: (text: string) => void) => ReactNode)

    // Layout
    title?: string
    onClose?: () => void
    /** Show "Beta" chip in header */
    showBetaChip?: boolean

    // Auto-start (for CSV)
    autoStartMessage?: string

    // Error handling
    onError?: (error: Error) => void
}

/**
 * Convert a protobuf Timestamp to milliseconds for sorting.
 */
export const getTimestampMs = (ts: { seconds: number | bigint; nanos: number } | undefined): number => {
    if (!ts) return 0
    return Number(ts.seconds) * 1000 + ts.nanos / 1000000
}
